import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CSSTransition } from 'react-css-transition'
import { getProductFrom } from '../../lib/utils'
import InputName from './InputName'
import PersonToggableButton from './PersonToggableButton'
import EditPersonIcon from '../../icons/editPersonIcon'
import InvitationIcon from '../../icons/invitationIcon'
import CheckmarkIcon from '../../icons/checkmarkIcon'
import TransitionStyles from '../../lib/transitionStyles'

const PersonRow = ({
  personIndex,
  person,
  hasRental,
  hasInstruction,
  toggle,
  onChange,
  personValid,
  bookerIsLoggedIn,
  bookerNotAttending,
  skus,
  personErrors
}) => {

  const activeIcon = () => {
    if (person && person.invite) {
      return <InvitationIcon sizeCss="w-8 h-8" />
    }
    if (person && personValid(person)) {
      return (
        <CheckmarkIcon sizeCss="h-6 w-6" />
      )
    }
    return (
      <EditPersonIcon sizeCss="w-8 h-8" />
    )
  }

  const activeIconColor = () => {
    if (person.invite) {
      return 'bg-sky'
    }
    return personValid(person) || person.membership ? 'bg-grass' : 'bg-grey'
  }

  const determinePassType = () => {
    if (person && person.membership) {
      return person.membership.type
    }
    return person.passType
  }

  const hasErrors = personErrors ? Object.values(personErrors).filter(item => item).length > 0 : false
  const disabled = person.isBooker && bookerIsLoggedIn && !bookerNotAttending && person.firstName && person.lastName

  return (
    <div className="flex">
      <button onClick={toggle} type="button" className="mr-6 focus:outline-none">
        <div
          style={{
          transition: 'all 300ms ease-out'
        }}
          className={`${activeIconColor(person, personIndex)} w-16 h-16 rounded-full flex items-center justify-center`}
        >
          {activeIcon(person)}
        </div>
      </button>
      <div className="flex-grow truncate">
        <h6 className="uppercase text-grey tracking-wide-2xl">
          {determinePassType()
            ?  <FormattedMessage id={`passTypes.${getProductFrom(determinePassType()).id}`} defaultMessage={getProductFrom(determinePassType()).defautName} />
            : (
              <>
                {person.invite
                  ? <FormattedMessage id="booking.person.byInvite" defaultMessage="By invitation" />
                  : <FormattedMessage id="booking.person.selectPass" defaultMessage="Select pass" />
                }
              </>
            )
          }
        </h6>

        {person.expanded && skus.length > 0 || hasErrors ? (
          <CSSTransition {...TransitionStyles} transitionAppear active={person.expanded || hasErrors}>
            <InputName
              onChange={onChange}
              person={person}
              disabled={disabled}
              personErrors={personErrors}
              bookerNotAttending={bookerNotAttending}
            />
          </CSSTransition>
        ) : (
          <PersonToggableButton
            personIndex={personIndex}
            invite={person.invite}
            ageCategory={person.ageCategory}
            hasRental={hasRental}
            hasInstruction={hasInstruction}
            insuranceCancellation={person.insuranceCancellation}
            toggle={toggle}
            person={person}
          />
        )}

      </div>
      <button type="button" onClick={toggle} className="ml-2 focus:outline-none">
        <svg
          style={{ transition: 'all 300ms ease-out' }}
          className={`${person.expanded && 'rotate-180'} fill-current h-4 w-4 text-harbor`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>              
      </button>
    </div>
  )
}

export default PersonRow
  